export default __webpack_public_path__ + "static/google_Desktop12-eea064d69cc560ebe6c3a62db9591c87.svg";